import { DocumentValue } from './model/document-value';
import { TemplateAttribute } from './model/template-attribute';
import { DocumentFormBuilderService } from './service/document-form-builder-service.service';
import { FormGroup } from '@angular/forms';
import { Document } from './model/document';
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { ObjectUnsubscribedError } from 'rxjs';
import { TemplateAttributeType } from './model/template-attribute-type.enum';


@Component({
    selector: 'app-document',
    templateUrl: './document.component.html',
    styleUrls: ['./document.component.scss'],
    standalone: false
})
export class DocumentComponent implements OnInit {

  @Input() document: Document;

  @Input() form: FormGroup;

  @Output() documentChanged = new EventEmitter<Document>();

  @Input() metaData: any;


  constructor(private documentFormBuilderService: DocumentFormBuilderService) { }

  ngOnInit() {

    const controls = this.documentFormBuilderService.createFormControls(this.document);
    for (const key of Object.keys(controls)) {
      this.form.addControl(key, controls[key]);
    }

    this.form.valueChanges.subscribe(formValues => {

      // ACHTUNG! Werte von deaktivierten Feldern sind nicht in den formValues enthalten, es auf den rawValues des Forms gearbeitet werden!
      const rawValues = this.form.getRawValue();

      const tmpDocValues: DocumentValue[] = [];

      this.document.rawValues = [];

      // alle Werte zwischenspeichern
      for (const k of Object.keys(rawValues)) {

        const value = new DocumentValue({ key: k, value: rawValues[k] });

        const attr = this.findAttributeForKey(k);1
        // Sonderbehandlung für Images, hier steht der content nicht in den Werten des Forms!
        if (attr?.type === TemplateAttributeType.PHOTO) {
          const imageValue = this.document.values.find(v => v.key === attr.key);
          tmpDocValues.push(imageValue);
        } else {
          tmpDocValues.push(value);
        }
        // Raw values beinhalten alle werte 
        this.document.rawValues.push(value);
      }



      // ausgeblendete Felder und Labels aus Werten entfernen
      for (const area of this.document.template.areas) {
        for (const attribute of area.attributes) {
          if (area.choiceAttribute != null && this.form.controls[area.choiceAttribute.key].value !== true) {
            const index = tmpDocValues.findIndex(v => v.key === attribute.key);
            if (index !== -1) {
              tmpDocValues.splice(index, 1);
            }
          } else if (TemplateAttributeType.LABEL === attribute.type) {
            // labels entfernen
            const index = tmpDocValues.findIndex(v => v.key === attribute.key);
            if (index !== -1) {
              tmpDocValues.splice(index, 1);
            }
          }
        }
      }

      this.document.values = tmpDocValues;
      this.documentChanged.next(this.document);
    });
  }

  private findAttributeForKey(key: string): TemplateAttribute {
    for (const area of this.document.template.areas) {
      for (const attr of area.attributes) {
        if (attr.key === key) {
          return attr;
        }
      }
    }

    return null;
  }
}
